export default "dist/images/block-testimonial-basic2.ba28833.png";